if (!window.__cardSwatchesRuntimeBound) {
  window.__cardSwatchesRuntimeBound = true;

  const updateCardMediaImages = (card, swatch) => {
    const imageSrc = swatch.dataset.imageSrc;
    if (!imageSrc) return;

    card.querySelectorAll('.card__media .media img').forEach((image) => {
      image.setAttribute('src', imageSrc);
      if (image.hasAttribute('data-src')) image.setAttribute('data-src', imageSrc);

      const imageSrcset = swatch.dataset.imageSrcset;
      if (imageSrcset) {
        image.setAttribute('srcset', imageSrcset);
        if (image.hasAttribute('data-srcset')) image.setAttribute('data-srcset', imageSrcset);
      } else {
        image.removeAttribute('srcset');
        if (image.hasAttribute('data-srcset')) image.removeAttribute('data-srcset');
      }

      const imageWidth = swatch.dataset.imageWidth;
      const imageHeight = swatch.dataset.imageHeight;
      if (imageWidth) image.setAttribute('width', imageWidth);
      if (imageHeight) image.setAttribute('height', imageHeight);

      const imageAlt = swatch.dataset.imageAlt;
      if (imageAlt) image.setAttribute('alt', imageAlt);
    });
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.card__swatch');
    if (!swatch) return;
    if (swatch.classList.contains('card__swatch--more')) return;

    event.preventDefault();

    const card = swatch.closest('.card-wrapper');
    if (!card) return;

    if (swatch.getAttribute('aria-disabled') === 'true') return;

    const variantId = swatch.dataset.variantId;
    const variantUrl = swatch.dataset.variantUrl;

    const baseUrl = card.dataset.productUrl;
    const urlSource = variantUrl || baseUrl;
    if (!urlSource) return;

    const url = new URL(urlSource, window.location.origin);
    if (variantId) {
      url.searchParams.set('variant', variantId);
    }
    const nextUrl = `${url.pathname}${url.search}${url.hash}`;

    const swatchGroup = swatch.closest('.card__swatches');
    if (swatchGroup) {
      swatchGroup.querySelectorAll('.card__swatch:not(.card__swatch--more)').forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
    }

    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');

    card.querySelectorAll('a[href]').forEach((link) => {
      const linkUrl = new URL(link.getAttribute('href'), window.location.origin);
      if (linkUrl.pathname === url.pathname) {
        link.setAttribute('href', nextUrl);
      }
    });

    card.querySelectorAll('[data-product-url]').forEach((element) => {
      const dataUrl = element.getAttribute('data-product-url');
      if (!dataUrl) return;
      const linkUrl = new URL(dataUrl, window.location.origin);
      if (linkUrl.pathname === url.pathname) {
        element.setAttribute('data-product-url', nextUrl);
      }
    });

    card.querySelectorAll('input.product-variant-id').forEach((input) => {
      if (!variantId) return;
      input.value = variantId;
      input.removeAttribute('disabled');
    });

    updateCardMediaImages(card, swatch);
  });
}
